<template>
  <div id="app" >

			<router-view :style="{ 'opacity': opacity }"
				frame="iphone-reg-frame"
				:page="page"
				:matchContent="matchContents"
				@answer="answer"
				@reset="reset">
			</router-view>

  </div>
</template>

<script>
import StarterPage from './components/StarterPage';
import QuestionPage from './components/QuestionPage';
import MatchPage from './components/MatchPage';

export default {
  name: 'app',
  components: {
    StarterPage, QuestionPage, MatchPage
  },
  mounted() {

		let self = this;
    // Get Answers from Param
    if (this.$route.params.answers) {
      this.answerString = this.$route.params.answers
    } else {
      this.answerString = "";
    }

		if(document.readyState === 'complete') {
      self.opacity = 1;
      //console.log("Finished Loading Before Mount")
		} else {

			window.onload = function() {
        self.opacity = 1;
        //console.log("Finished Loading After Mount")
			}
		}
  },
  data() {
    return {
      opacity: 0,

      devices:
        {iphone: true,
        iphonePlus: false,
        ipad: false,
        all: false}
      ,
      questions: [
        {
          question: "What’s your<br>skincare IQ?",
          answers: [
            {
              type: "string",
              content: "All about<br>the basics",
              next_q_id: 1
            },{
              type: "string",
              content:  "I have a regimen, but it's a WIP",
              next_q_id: 1
            },{
              type: "string",
              content: "Skincare<br>Guru",
              next_q_id: 1
            },{
              type: "string",
              content: "Should I be<br>washing<br>my face?",
              next_q_id: 1
            },
          ]
        },
        {
          question: "Yay, you have Friday off!<br>How are you spending it?",
          answers: [
            {
              type: "img",
              content: "/static/beach.png",
              alt: "The Beach",
              next_q_id: 2
            },{
              type: "img",
              content:  "/static/ski.png",
              alt: "Skiing",
              next_q_id: 2
            },{
              type: "img",
              content: "/static/nail-polish_1f485.png",
              alt: "Nails",
              next_q_id: 2
            },{
              type: "img",
              content: "/static/tv2.png",
              alt: "TV",
              next_q_id: 2
            },
          ]
        },
        {
          question: "What word<br>best describes<br>your skin type?",
          answers: [
            {
              type: "string",
              content: "Oily",
              next_q_id: 3
            },{
              type: "string",
              content:  "Dry",
              next_q_id: 3
            },{
              type: "string",
              content: "Normal",
              next_q_id: 3
            },{
              type: "string",
              content: "Combination",
              next_q_id: 3
            },{
              type: "string",
              content: "I don’t know…",
              next_q_id: 3
            },{
              type: "string",
              content: "FLAWLESS",
              next_q_id: 3
            },

          ]
        },
        {
          question: "When it comes to bad habits,<br>you’re most guilty of…",
          answers: [
            {
              type: "string",
              content: "Not getting<br>your daily 8<br>glasses of water",
              next_q_id: 4
            },{
              type: "string",
              content: "Forgetting to<br>take your<br>make-up off<br>before bed",
              next_q_id: 4
            },{
              type: "string",
              content: "NEVER<br>wearing SPF",
              next_q_id: 4
            },{
              type: "string",
              content: "Staying up<br>WAY past<br>your bedtime",
              next_q_id: 4
            },
          ]
        },
        {
          question: "What major<br>skin concern<br>has you like",
          emojis: "/static/emojis.png",
          answers: [
            {
              type: "string",
              content: "Dark Spots",
              next_q_id: null,
              complete: 2
            },{
              type: "string",
              content: "Pores",
              next_q_id: null,
              complete: 0
            },{
              type: "string",
              content: "Dryness",
              next_q_id: null,
              complete: 1
            },{
              type: "string",
              content: "Wrinkles &<br>Radiance",
              next_q_id: null,
              complete: 3
            },
          ]
        },
      ],
      matchContents: [{
        title: "Pore Control Serum",
        img: "/static/pore-control-with-flower.png",
        url: "https://ad.doubleclick.net/ddm/clk/419654344;221210708;y?https://www.clarinsusa.com/en/pore-control-serum/C070400158.html?&utm_medium=Social&utm_campaign=SerumMatchQuiz",
      },{
        title: "Hydra-Essentiel Bi-Phase Serum",
        img: "/static/hydra-essentiel-leaf.png",
        url: "https://ad.doubleclick.net/ddm/clk/419654344;221210708;y?https://www.clarinsusa.com/en/hydra-essentiel-bi-phase-serum---normal-to-dry-skin/C070400081.html?&utm_medium=Social&utm_campaign=SerumMatchQuiz",
      },{
        title: "Mission Perfection Serum",
        img: "/static/mission-perfect-cherries.png",
        url: "https://ad.doubleclick.net/ddm/clk/419654344;221210708;y?https://www.clarinsusa.com/en/mission-perfection-serum/80001773.html?&utm_medium=Social&utm_campaign=SerumMatchQuiz",
      },{
        title: "Double Serum",
        img: "/static/double-serum-root.png",
        url: "https://ad.doubleclick.net/ddm/clk/419654344;221210708;y?https://www.clarinsusa.com/en/double-serum/80025863.html?&utm_medium=Social&utm_campaign=SerumMatchQuiz",
      }],
      answerString: "",
    }
  },
  computed: {
    q_id() {
      return this.$route.params.q_id;
    },
    page() {
      if (this.q_id) {
        return this.questions[this.q_id];
      } else {
        return {}
      }
    },
    answers() {
      let answer_param = this.q_id;
      if (answer_param && answer_param != "none") {
        let temp_answers = answer_param.split('&');
        temp_answers = temp_answers.map(answer => {
          answer = answer.split(':');
          console.assert(answer.length = 2);

          return {
            q_id: answer[0],
            q_ans: answer[1]
          }
        });
        return temp_answers;
      }

      else {
        return [];
      }
    }
  },
  methods: {
    changeQuestion(id, complete) {
      // Go to Next Questions
      let answerString = this.answerString

      if (complete || complete == 0) {

        this.$router.push({
          name: "match",
          params: {answers: answerString, product: complete},
        });
      }

      else if (id < this.questions.length && id > -1) {
        this.$router.push({
          name: "questions",
          params: {q_id: id, answers: answerString}
        });
      }
    },
    answer(q_id, answer_index, answer) {
      if (this.answerString == 'none') {
        this.answerString = String(q_id) + ":" + String(answer_index);
      } else {
        this.answerString = this.$route.params.answers + "&" + String(q_id) + ":" + String(answer_index);
      }

      this.changeQuestion(answer.next_q_id, answer.complete)
    },
    reset() {
      this.answerString = "none";
      this.$forceUpdate();
    },
    toggleViews(obj){
      //console.log(obj)
      if(obj !== 'all'){

        this.devices.iphone = false
        this.devices.iphonePlus = false
        this.devices.ipad = false
        this.devices.all = false

         this.devices[obj] = true
      }else{
        this.devices.iphone = true
        this.devices.iphonePlus = true
        this.devices.ipad = true
      }
    }
  },
}
</script>

<style lang="scss">

html, body {
  height: 100%;
  margin: 0;
}
body {
  font-size: 16px;
  *{
    box-sizing: border-box;
  }
}
nav{
  ul{
    display: flex;
    list-style-type: none;
    margin: 10px 0 60px 0;
    padding: 0;
    justify-content:center;

    li{
      margin: 10px;

      &.active{
        font-weight: bold;
      }
    }
  }
}
.header {
  z-index: 500;

  img {
    width: 100%;
    max-width: 100%;
    display: block;
  }
}

#app {
  min-height: 550px;

  // iphone 6,7,8
  @media only screen
  and (min-device-width : 375px)
  and (max-device-width : 667px)
  and (orientation : portrait) { min-height: 550px; }

  // iphone 6,7,8 Plus
  @media only screen
and (min-device-width : 414px)
and (max-device-width : 736px)
and (orientation : portrait) { min-height: 650px; }

// iphone 5
@media only screen
and (min-device-width : 320px)
and (max-device-width : 568px)
and (orientation : portrait) { min-height: 480px; }

  font-family: $sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  color: $color-primary;
  background-color: #ddd;

  margin: auto;

  position: relative;
  overflow: hidden;

  display: flex;
	flex-direction: column;
	height: 100%;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 100px;
}

.screen-frame {
  background-color: #fff;
  border: 1px #efefef solid;

  display: flex;
  flex-direction: column;

  position: relative;

  box-shadow: 0px 5px 15px rgba(0,0,0,0.5);
}

// .answer-card {
// 	// @include media-query($medium-up) {
// 	// 	width: 16%;
// 	// }

// 	// .length6 &:before{
// 	// 	@include media-query($small-down) {
// 	// 		padding-bottom: 76.375%;
// 	// 	}
// 	// 	@include media-query($smaller-up) {
// 	// 		padding-bottom: 125%;
// 	// 	}
// 	// }

// 	// &:before {
// 	// 	@include media-query($smaller-up) {
// 	// 		padding-bottom: 125%;
// 	// 	}
// 	// }
// }

.finder-page {
  flex-grow: 1;
  padding: 0 10px;
}
</style>
